export function MsTag({ label }: { label: string | null }) {
  if (!label) return null;
  return (
    <span
      style={{
        fontSize: 9,
        fontWeight: 600,
        padding: '1px 6px',
        borderRadius: 3,
        border: '1px solid var(--border)',
        color: 'var(--text-muted)',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
